import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { baseUrl } from "../../utilities/configurations";
import { KeyboardArrowLeft } from "@mui/icons-material";
import apiRequest from "../../utilities/request";
import DoctorsContent from "./DoctorsContent";
import Button from "../../Components/Button";
import DateContent from "./DateContent";
import { useEffect } from "react";
import dayjs from "dayjs";
import "./style.css";

function StepThree() {
  const {
    setSelectedDoctorBySearchAvailableTime,
    setSelectedSpecialization,
    setSelectedDoctorBySearch,
    selectedSpecialization,
    selectedDoctorBySearch,
    setToSearchByDoctor,
    setPreferredDoctor,
    setAvailableDates,
    showDoctorsModal,
    toSearchByDoctor,
    setDisplayAlert,
    setSelectedDate,
    selectedClinic,
    selectedDoctor,
    setPhysicians,
    selectedTime,
    selectedDate,
    setLoadState,
    navigate,
    month,
    year,
  } = useConsultDoctorContext();

  useEffect(() => {
    if (selectedSpecialization && !showDoctorsModal) {
      getCalendarId();
    }
  }, [selectedSpecialization, showDoctorsModal]);

  useEffect(()=>{
    if (selectedDate && selectedDoctorBySearch) {
      getSelectedDoctorBySearchAvailableTime();
    }
  },[selectedDate, selectedDoctorBySearch])

  const getPhysicianDates=async(id)=>{
    try {
      setAvailableDates([]);
      const res = await apiRequest(
        baseUrl +
          `/consult/dates?month=${year}-${month}&specializationId=${selectedSpecialization.id}&physicianId=${id}`,
        "GET"
      );
      if (res.data) {
        setAvailableDates((prevData) => {
          const existingDatesSet = new Set(prevData.map(date => JSON.stringify(date)));
          const newUniqueDates = res.data.filter(date => !existingDatesSet.has(JSON.stringify(date)));
          return [...prevData, ...newUniqueDates];
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getAvailableDates = (physicians) => {
    physicians?.forEach((data) => {
      getPhysicianDates(data.id);
    });
  };

  const getCalendarId = async () => {
    const res = await apiRequest(
      baseUrl +
        `/consult/physicians?specializationId=${selectedSpecialization.id}`,
      "GET"
    );
    setPhysicians(res.data || []);
    getAvailableDates(res.data || []);
  };

  const getSelectedDoctorBySearchAvailableTime = async (state) => {
    try {
      setLoadState(state || "get times");
      const res = await apiRequest(
        baseUrl +
          `/consult/times?date=${dayjs(selectedDate).format(
            "YYYY-MM-DD"
          )}&specializationId=${
            selectedDoctorBySearch?.specializationId
          }&physicianId=${selectedDoctorBySearch?.id}`,
        "GET"
      );
      if (!res.error) {
        let slots = res.data || [];
        setSelectedDoctorBySearchAvailableTime(
          slots.map((slot) => dayjs(slot.time).format("HH:mm"))
        );
        setLoadState("get times success");
      } else if (res.status >= 500) {
        setLoadState("get times ISE");
      } else {
        setLoadState("get times failed");
      }
    } catch (error) {
      setLoadState("get times timeout");
    }
  };

  const stepThreeValidation=()=>{
    if(toSearchByDoctor){
      return selectedDoctorBySearch !== null &&
      selectedTime !== undefined;
    }else{
      return selectedSpecialization !== null &&
      selectedDoctor !== undefined &&
      selectedTime !== undefined;
    }
  }

  const nextPage = () => {
    navigate("/consult-doctor/booking-summary");
  };

  const handleNext = () => {
    if (stepThreeValidation()) {
      nextPage();
    } else setDisplayAlert(true);
  };

  const handleBack = () => {
    navigate(-1);
    setSelectedDate(null);
    setSelectedSpecialization(null);
    setSelectedDoctorBySearch(null);
    setToSearchByDoctor(false);
    setPreferredDoctor(null);
  };

  let mainContent = (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-1">
              Consult a doctor
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
          <div className="p-3">
            <CustomizedProgressBar value={75} />
          </div>
        </div>
        <div className="w-full px-3">
          <div className="text-sm text-[#60656D]">
            Choose your preferred date and time for your visit.
          </div>
          <div className="w-full my-2 cursor-pointer">
            <div className=" w-full text-sm rounded-lg p-4 bg-[#f6f7f7]">
              <div className="font-bold">{selectedClinic.providerName}</div>
              <div>{selectedClinic.address}</div>
            </div>
          </div>
          <DateContent/>
        </div>
        <div className="flex w-full p-4 mt-auto sm:justify-end">
          <Button
            disabled={!stepThreeValidation()}
            className={`h-14 w-full sm:w-22.5 ${
              !stepThreeValidation() ? "bg-[#F6F7F7]" : "bg-[#0053CC]"
            } rounded-xl`}
            onClick={handleNext}
          >
            <p
              className={`font-medium font-sans text-xs ${
                !stepThreeValidation() ? "text-[#A3A7AB]" : "text-white"
              }`}
            >
              Continue
            </p>
          </Button>
        </div>
      </div>
    </div>
  );

  if (showDoctorsModal) {
    mainContent = <DoctorsContent/>
  }

  return mainContent;
}

export default StepThree;